import store from '@/store'

import { ROLE_USER, ROLE_MANAGER, ROLE_ADMIN, ROLE_MAESTRO, ROLE_SCORE_MAP } from "@/constants"
import { isUseFeature } from "@/helpers/features"

const ROLE_DEFAULT_PAGE_MAP = {
  [ROLE_ADMIN]: "Dashboard",
  [ROLE_MANAGER]: "Dashboard",
  [ROLE_USER]: "Schedules"
}

const ROUTES_FEATURES = {

}

export async function isAuthenticated(to, from, next) {
  // Проверяем, требуется ли аутентификация для данного роута
  if (to.meta.auth) {
    // Проверяем наличие токена в localStorage
    const token = localStorage.getItem('token')

    if (!token) {
      localStorage.setItem(
        "login-redirect-page",
        JSON.stringify({ path: to.path, query: to.query, params: to.params })
      )
      // Если токена нет, перенаправляем на страницу входа
      next({ name: 'Login' })
      return
    }
    
    // Проверяем, есть ли currentUser в store
    const currentUser = store.state.auth.currentUser
    
    if (Object.keys(currentUser).length === 0) {
      try {
        // Если currentUser пустой, получаем данные пользователя
        await store.dispatch('auth/fetchCurrentUser')
        // После успешного получения пользователя разрешаем переход
        nextWithAutorization(to, from, next)
      } catch (error) {
        // Токен мог смениться, пока шёл запрос: интерцептор возвращает токен
        // маэстро, когда имперс-токен протух. Такую сессию не стираем — пробуем
        // загрузить пользователя под новым токеном.
        if (localStorage.getItem('token') !== token) {
          try {
            await store.dispatch('auth/fetchCurrentUser')
            nextWithAutorization(to, from, next)
            return
          } catch (retryError) {
            // Новый токен тоже не работает — обычный выход.
          }
        }

        // Сессию рвём только на отказ авторизации. Любая другая ошибка —
        // 5xx во время выкладки, обрыв сети, отсутствие ответа вовсе — это не
        // повод разлогинивать: раньше здесь стирался токен на любом ответе с
        // ошибкой, и пользователи выпадали из сессии на каждом перезапуске
        // backend, хотя токен жив ещё недели.
        const status = error?.response?.status

        // 403 — организация заблокирована за неуплату: форма входа показывает
        // сумму и ссылку на оплату, поэтому уводим туда же.
        if (status !== 401 && status !== 403) {
          next()
          return
        }

        localStorage.removeItem('token')
        next({ name: 'Login' })
      }
    } else {
      // Если currentUser уже есть, разрешаем переход
      nextWithAutorization(to, from, next)
    }
  } else {
    if (to.name == undefined) {
      next({ name: from.name })
    } else if (to.name === 'Login' && from.name && localStorage.getItem('token')) {
      // Переход внутри приложения (в том числе кнопкой «назад» после входа):
      // авторизованному форма входа не показывается. Прямое открытие /login
      // остаётся доступным — там `from.name` пуст.
      const currentUser = store.state.auth.currentUser
      next({ name: ROLE_DEFAULT_PAGE_MAP[currentUser.role] || 'Dashboard' })
    } else {
      //   // Если роут не требует аутентификации, проверяем, аутентифицирован ли пользователь
      // const token = localStorage.getItem('token')
      // // if (token) localStorage.removeItem('token') 
      next()
    }
  }
}


export function nextWithAutorization(to, from, next) {
  if (!localStorage.getItem('token')) {
    next()
  } else {
    const currentUser = store.state.auth.currentUser
    const userRoleScore = ROLE_SCORE_MAP[currentUser.role]
    const routeRoleScore = ROLE_SCORE_MAP[to.meta.authorize] || 1

    if (userRoleScore === ROLE_SCORE_MAP[ROLE_MAESTRO]) {
      if (to.meta.authorize === ROLE_MAESTRO) {
        next()
      } else {
        next({ name: "MaestroDashboard" })
      }
      return
    }

    if (userRoleScore >= routeRoleScore) {
      nextWithFeatureChecking(currentUser, to, from, next)
    } else {
      if (ROLE_DEFAULT_PAGE_MAP[currentUser.role] === to.name) {
        next()
      } else {
        next({ name: ROLE_DEFAULT_PAGE_MAP[currentUser.role] })
      }
    }
  }
}

function nextWithFeatureChecking(currentUser, to, from, next) {
  if (to.meta.feature) {
    if (isUseFeature(to.meta.feature)) {
      next()
    } else {
      next({ name: from.name || ROLE_DEFAULT_PAGE_MAP[currentUser.role] })
    }
  } else {
    next()
  }
}